module.exports = __webpack_public_path__ + "img/20210906-1630913511591441.4e7ed1f0.png";